var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSrtruckingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 914.254,
    height: 568.421,
    viewBox: "0 0 914.254 568.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(2146.411 8157.731)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 34,
    y2: 296,
    transform: "translate(-2126.45 -8025.74) rotate(-3)",
    fill: "none",
    stroke: "#b7ff64",
    strokeWidth: 40
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 32,
    y2: 296,
    transform: "translate(-2017.599 -8031.444) rotate(-3)",
    fill: "none",
    stroke: "#f83f2f",
    strokeWidth: 40
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x1: 33,
    y2: 296,
    transform: "translate(-1911.745 -8036.992) rotate(-3)",
    fill: "none",
    stroke: "#b7ff64",
    strokeWidth: 40
  }), /*#__PURE__*/React.createElement("text", {
    id: "SR",
    transform: "translate(-1841.169 -7750.793) rotate(1)",
    fill: "#b7ff64",
    fontSize: 405,
    fontFamily: "CenturyPSPro-Bold, Century PS Pro",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SR")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrtruckingLogo);
export default __webpack_public_path__ + "static/media/srtrucking_logo.88f7a15f3e11fe28d8a37a9f2b38487e.svg";
export { ForwardRef as ReactComponent };